export const mockIndicadores = {
    inscritosPorEspecialidade: [
        { especialidade: 'Cardiologia', quantidade: 12 },
        { especialidade: 'Ortopedia', quantidade: 8 },
        { especialidade: 'Dermatologia', quantidade: 6 },
        { especialidade: 'Pediatria', quantidade: 15 },
        { especialidade: 'Neurologia', quantidade: 4 },
        { especialidade: 'Oftalmologia', quantidade: 7 },
    ],
    inscritosPorMunicipio: [
        { municipio: 'Presidente Prudente', quantidade: 28 },
        { municipio: 'Presidente Venceslau', quantidade: 5 },
        { municipio: 'MartinÃ³polis', quantidade: 3 },
        { municipio: 'Ãlvares Machado', quantidade: 4 },
        { municipio: 'Regente FeijÃ³', quantidade: 2 },
    ],
    resumo: {
        totalInscritos: 52,
        inscricoesDeferidas: 34,
        inscricoesIndeferidas: 3,
        documentosPendentes: 8,
        pagamentosPendentes: 12,
        candidatosEmCurso: 18,
        certificadosEmitidos: 14,
        candidatosHabilitados: 14,
        candidatosAprovados: 10,
        taxaConversao: 19.2,
        percentualConclusaoCurso: 77.8,
    },
};

export const mockDocumentosExigidos = [
    { id: 1, descricao: 'Diploma de Medicina', obrigatorio: true },
    { id: 2, descricao: 'Carteira do CRM', obrigatorio: true },
    { id: 3, descricao: 'CertidÃ£o de RQE', obrigatorio: true },
    { id: 4, descricao: 'Certificado de ResidÃªncia MÃ©dica', obrigatorio: true },
    { id: 5, descricao: 'TÃ­tulo de especialista AMB', obrigatorio: false },
    { id: 6, descricao: 'Comprovante de endereÃ§o', obrigatorio: true },
    { id: 7, descricao: 'Certificados de pÃ³s-graduaÃ§Ã£o', obrigatorio: false },
    { id: 8, descricao: 'PublicaÃ§Ãµes, livros e artigos', obrigatorio: false },
];

function documento(tipoId, arquivo, status, enviadoEm) {
    return {
        tipoId, nome: arquivo, tamanho: 482304, enviadoEm, status,
    };
}

function documentosPor(lista) {
    return lista.reduce((acumulado, item) => {
        acumulado[item.tipoId] = item;
        return acumulado;
    }, {});
}

export const mockInscricoes = [
    {
        id: 1, editalId: 1, nome: 'Dr. Carlos Eduardo Silva', cpf: '123.456.789-01', crm: '12345-SP', especialidade: 'Cardiologia', status: 1, dataInscricao: '2026-07-15', municipio: 'Presidente Prudente', parecer: '', nivelamentoConcluido: false,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'em-analise', '2026-07-16'),
            documento(2, 'carteira-crm.pdf', 'em-analise', '2026-07-16'),
        ]),
    },
    {
        id: 2, editalId: 1, nome: 'Dra. Ana Paula Ferreira', cpf: '987.654.321-00', crm: '54321-SP', especialidade: 'Dermatologia', status: 2, dataInscricao: '2026-07-10', municipio: 'Presidente Prudente', parecer: 'DocumentaÃ§Ã£o completa e conforme edital.', nivelamentoConcluido: false,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'aprovado', '2026-07-11'),
            documento(2, 'carteira-crm.pdf', 'aprovado', '2026-07-11'),
            documento(3, 'certidao-rqe.pdf', 'aprovado', '2026-07-11'),
            documento(4, 'certificado-residencia.pdf', 'aprovado', '2026-07-11'),
            documento(6, 'comprovante-endereco.pdf', 'aprovado', '2026-07-11'),
        ]),
    },
    {
        id: 3, editalId: 1, nome: 'Dr. Roberto Almeida', cpf: '456.789.123-45', crm: '67890-SP', especialidade: 'Ortopedia', status: 1, dataInscricao: '2026-07-18', municipio: 'MartinÃ³polis', parecer: '', nivelamentoConcluido: false,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'em-analise', '2026-07-19'),
            documento(2, 'carteira-crm.pdf', 'em-analise', '2026-07-19'),
            documento(3, 'certidao-rqe.pdf', 'reprovado', '2026-07-19'),
            documento(4, 'certificado-residencia.pdf', 'em-analise', '2026-07-19'),
            documento(6, 'comprovante-endereco.pdf', 'em-analise', '2026-07-19'),
        ]),
    },
    {
        id: 4, editalId: 1, nome: 'Dra. Mariana Costa', cpf: '321.654.987-12', crm: '11223-SP', especialidade: 'Pediatria', status: 3, dataInscricao: '2026-07-05', municipio: 'Presidente Prudente', parecer: 'CRM divergente do documento anexado.', nivelamentoConcluido: false,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'em-analise', '2026-07-06'),
            documento(2, 'carteira-crm.pdf', 'reprovado', '2026-07-06'),
            documento(3, 'certidao-rqe.pdf', 'em-analise', '2026-07-06'),
        ]),
    },
    {
        id: 5, editalId: 1, nome: 'Dr. Fernando Nascimento', cpf: '654.987.321-67', crm: '44556-SP', especialidade: 'Neurologia', status: 2, dataInscricao: '2026-07-12', municipio: 'Ãlvares Machado', parecer: 'Aprovado em conformidade com o edital 001/2026.', nivelamentoConcluido: true,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'aprovado', '2026-07-13'),
            documento(2, 'carteira-crm.pdf', 'aprovado', '2026-07-13'),
            documento(3, 'certidao-rqe.pdf', 'aprovado', '2026-07-13'),
            documento(4, 'certificado-residencia.pdf', 'aprovado', '2026-07-13'),
            documento(6, 'comprovante-endereco.pdf', 'aprovado', '2026-07-13'),
        ]),
    },
    {
        id: 6, editalId: 1, nome: 'Dra. Juliana Mendes', cpf: '789.123.456-78', crm: '77889-SP', especialidade: 'Cardiologia', status: 1, dataInscricao: '2026-07-20', municipio: 'Presidente Prudente', parecer: '', nivelamentoConcluido: false,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'em-analise', '2026-07-21'),
        ]),
    },
    {
        id: 7, editalId: 1, nome: 'Dr. Paulo Ricardo Souza', cpf: '234.567.890-34', crm: '99001-SP', especialidade: 'Oftalmologia', status: 2, dataInscricao: '2026-07-08', municipio: 'Regente FeijÃ³', parecer: 'Aprovado.', nivelamentoConcluido: false,
        documentos: documentosPor([
            documento(1, 'diploma-medicina.pdf', 'aprovado', '2026-07-09'),
            documento(2, 'carteira-crm.pdf', 'aprovado', '2026-07-09'),
            documento(3, 'certidao-rqe.pdf', 'aprovado', '2026-07-09'),
            documento(4, 'certificado-residencia.pdf', 'aprovado', '2026-07-09'),
            documento(6, 'comprovante-endereco.pdf', 'aprovado', '2026-07-09'),
        ]),
    },
    {
        id: 8, editalId: 1, nome: 'Dra. Camila Oliveira', cpf: '567.890.234-56', crm: '22334-SP', especialidade: 'Pediatria', status: 1, dataInscricao: '2026-07-22', municipio: 'Presidente Prudente', parecer: '', nivelamentoConcluido: false,
        documentos: {},
    },
];

function cronogramaVazio() {
    return {
        documentos: { dataInicio: '', dataFim: '' },
        pagamento: { dataInicio: '', dataFim: '' },
        analiseDocumental: { dataInicio: '', dataFim: '' },
        cursoNivelamento: { dataInicio: '', dataFim: '' },
        recursos: { dataInicio: '', dataFim: '' },
        integracao: { dataInicio: '', dataFim: '' },
    };
}

export const mockEditais = [
    {
        id: 1,
        titulo: 'Edital 001/2026 â Processo Seletivo Novos Cooperados',
        status: 'Aberto',
        dataAbertura: '2026-07-01',
        dataEncerramento: '2026-09-30',
        vagasDisponiveis: 5,
        arquivo: 'edital-001-2026.pdf',
        vagas: [
            { especialidadeId: 1, cidade: 'Presidente Prudente', quantidade: 3 },
            { especialidadeId: 11, cidade: 'Presidente Prudente', quantidade: 2 },
        ],
        cronograma: {
            documentos: { dataInicio: '2026-09-01', dataFim: '2026-10-15' },
            pagamento: { dataInicio: '2026-10-16', dataFim: '2026-10-31' },
            analiseDocumental: { dataInicio: '2026-10-16', dataFim: '2026-11-15' },
            cursoNivelamento: { dataInicio: '2026-11-16', dataFim: '' },
            recursos: { dataInicio: '2026-11-20', dataFim: '2026-11-30' },
            integracao: { dataInicio: '2026-12-15', dataFim: '' },
        },
    },
    {
        id: 2,
        titulo: 'Edital 002/2026 â Processo Seletivo Especialidades CirÃºrgicas',
        status: 'Rascunho',
        dataAbertura: '2026-10-01',
        dataEncerramento: '2026-12-15',
        vagasDisponiveis: 3,
        arquivo: '',
        vagas: [
            { especialidadeId: 9, cidade: 'Presidente Prudente', quantidade: 3 },
        ],
        cronograma: cronogramaVazio(),
    },
    {
        id: 3,
        titulo: 'Edital 003/2025 â Processo Seletivo Geral',
        status: 'Encerrado',
        dataAbertura: '2025-06-01',
        dataEncerramento: '2025-12-31',
        vagasDisponiveis: 0,
        arquivo: 'edital-003-2025.pdf',
        vagas: [],
        cronograma: cronogramaVazio(),
    },
];
